import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { knowledgeAuthContinueStorageKey } from "utils/knowledgeAuthContinue";

/**
 * After Cognito SSO returns to `/`, resume a pending Knowledge handoff by
 * navigating to `/auth/continue` (params live in sessionStorage).
 */
export function KnowledgeAuthContinueResume() {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authStatus !== "authenticated") {
      return;
    }
    if (location.pathname === "/auth/continue") {
      return;
    }
    try {
      if (sessionStorage.getItem(knowledgeAuthContinueStorageKey()) == null) {
        return;
      }
    } catch {
      return;
    }
    navigate("/auth/continue", { replace: true });
  }, [authStatus, location.pathname, navigate]);

  return null;
}
